const locale = {
    placeholder: '시간 선택',
};
export default locale;
